import SabilTakhmeenCreate from "./SabilTakhmeenCreate";

export default {
  create: SabilTakhmeenCreate,
  name: "sabilTakhmeen",
};
